export const translations = {
  fr: {
    nav: {
      magazine: "Magazine",
      articles: "Articles",
      founder: "La Fondatrice",
      services: "Régie & Communication",
      appointment: "Prise de rendez-vous",
      quote: "Demande de devis",
      client: "Espace client",
      login: "Connexion",
      logout: "Déconnexion",
      dashboard: "Mon espace",
      admin: "Administration",
    },
    home: {
      overline: "Regard africain · Portée internationale",
      h1: "L'intelligence économique du continent, avec la rigueur d'une référence mondiale.",
      sub: "Depuis plus d'une décennie, GLOBAL AFRIQUE INTERNATIONAL éclaire décideurs, investisseurs et institutions sur les grandes transformations du continent.",
      ctaMag: "Découvrir le magazine",
      ctaQuote: "Demander un devis",
      latest: "Actualités éditoriales",
      topRank: "Classements TOP BANQUES & TOP COMPAGNIES",
      topRankDesc: "Notre observatoire annuel des champions économiques panafricains. Une lecture stratégique reconnue par les hautes autorités et les dirigeants d'entreprises.",
      founder: "La Fondatrice",
      founderSub: "Une vision panafricaine, une signature éditoriale.",
      readMore: "Lire l'article",
      viewAll: "Voir tous les articles",
      reachOverline: "Distribution internationale",
      reachTitle: "Une audience de décideurs dans plus de 100 pays",
      reachItems: [
        { k: "100+", v: "Pays couverts" },
        { k: "10+", v: "Années d'expertise" },
        { k: "N°1", v: "Magazine d'affaires panafricain" },
        { k: "1M+", v: "Lecteurs qualifiés" },
      ],
      quoteBlock: "Nos tarifs sont personnalisés. Partagez vos besoins — nous vous répondons sous 48h ouvrées avec une proposition sur mesure.",
      newsletter: "Recevoir nos éditions numériques",
      newsletterSub: "Inscrivez-vous à notre newsletter confidentielle dédiée aux dirigeants.",
      subscribe: "S'inscrire",
      subscribed: "Merci, vous êtes inscrit(e).",
    },
    magazine: {
      title: "Kiosque Numérique",
      sub: "Chaque édition du magazine GAI, feuilletable en mode immersif.",
      read: "Ouvrir l'édition",
      download: "Télécharger le PDF",
      noPdf: "PDF bientôt disponible",
    },
    articles: {
      title: "Articles",
      sub: "Analyses, classements, interviews et dossiers stratégiques.",
      cats: {
        all: "Tous",
        finance: "Finance",
        politique: "Politique",
        "socio-culturel": "Socio-culturel",
        interview: "Interviews",
        top: "Classements",
      },
    },
    founder: {
      title: "Mme Bijoux Milton Kilandamoko",
      role: "Fondatrice & Éditrice — GLOBAL AFRIQUE INTERNATIONAL",
      quote: "« Faire de l'Afrique une lecture du monde, et du monde une lecture africaine. »",
      bio: "Entrepreneure panafricaine engagée, Madame Bijoux Milton Kilandamoko dirige GLOBAL AFRIQUE INTERNATIONAL depuis sa création. Journaliste et stratège en communication, elle a bâti en une décennie une plateforme média de référence, présente dans plus de 100 pays, reconnue par les plus hautes autorités, les dirigeants d'entreprises, les banquiers et les organisations internationales.",
      vision: "Sa vision : positionner l'Afrique comme acteur structurant du débat économique mondial, avec une ligne éditoriale engagée, indépendante et exigeante.",
      cta: "Réserver un entretien privé",
    },
    services: {
      title: "Régie publicitaire & Communication",
      sub: "Une offre complète pour renforcer votre visibilité et votre impact en Afrique.",
      blocks: [
        { t: "Régie publicitaire", d: "Emplacements premium dans le magazine, numéros spéciaux, campagnes ciblées décideurs." },
        { t: "Communication institutionnelle", d: "Prises de parole dirigeants, dossiers stratégiques, relations publiques continentales." },
        { t: "Contenus premium", d: "Interviews exclusives, portraits, études de cas, dossiers sectoriels." },
        { t: "Partenariats médias", d: "Co-éditions, événements, classements co-signés, diffusion panafricaine et internationale." },
      ],
      pricing: "Les tarifs ne sont pas publics. Chaque dispositif fait l'objet d'une proposition personnalisée.",
      cta: "Demander un devis",
    },
    quote: {
      title: "Demande de devis personnalisé",
      sub: "Dites-nous tout — notre service commercial vous répond sous 48h ouvrées.",
      fullName: "Nom complet",
      company: "Entreprise",
      email: "Email professionnel",
      phone: "Téléphone",
      country: "Pays",
      service: "Nature de la demande",
      budget: "Budget indicatif",
      message: "Votre projet",
      services: {
        publicite: "Publicité magazine",
        regie: "Régie publicitaire",
        communication: "Communication institutionnelle",
        partenariat: "Partenariat média",
        "contenu-premium": "Contenus premium / Interviews",
      },
      submit: "Envoyer la demande",
      success: "Demande envoyée. Nous revenons vers vous sous 48h.",
      error: "Échec de l'envoi. Merci de réessayer.",
    },
    appointment: {
      title: "Prise de rendez-vous avec la Fondatrice",
      sub: "Entretiens confidentiels — sur invitation ou demande qualifiée.",
      fullName: "Nom complet",
      email: "Email",
      phone: "Téléphone",
      company: "Entreprise",
      date: "Date souhaitée",
      topic: "Objet de l'entretien",
      message: "Contexte",
      submit: "Envoyer ma demande de RDV",
      success: "Demande enregistrée. La Fondatrice reviendra vers vous personnellement.",
    },
    auth: {
      loginTitle: "Espace Client",
      loginSub: "Accédez à vos demandes, brochures et contenus premium.",
      registerTitle: "Créer un compte",
      registerSub: "Réservé aux dirigeants, annonceurs et partenaires qualifiés.",
      email: "Email",
      password: "Mot de passe",
      name: "Nom complet",
      login: "Se connecter",
      register: "Créer mon compte",
      google: "Continuer avec Google",
      noAccount: "Pas encore de compte ?",
      hasAccount: "Déjà un compte ?",
      createOne: "Créer un compte",
      signIn: "Se connecter",
    },
    dashboard: {
      welcome: "Bienvenue",
      myQuotes: "Mes demandes de devis",
      myAppointments: "Mes rendez-vous",
      brochures: "Brochures & ressources",
      noItem: "Aucun élément pour l'instant.",
      download: "Télécharger",
      logout: "Se déconnecter",
    },
    admin: {
      title: "Administration GAI",
      stats: "Indicateurs",
      articles: "Articles",
      magazines: "Magazines",
      brochures: "Brochures",
      quotes: "Demandes de devis",
      appointments: "Rendez-vous",
      newArticle: "Nouvel article",
      newMagazine: "Nouvelle édition",
    },
    footer: {
      tagline: "Magazine d'affaires panafricain — Communication & Régie",
      rights: "Tous droits réservés",
      legal: "Mentions légales",
      privacy: "Confidentialité",
      contact: "Contact",
    },
    common: {
      loading: "Chargement…",
      close: "Fermer",
      previous: "Précédent",
      next: "Suivant",
      prev: "Précédent",
      open: "Ouvrir",
      sending: "Envoi…",
    },
  },

  en: {
    nav: {
      magazine: "Magazine",
      articles: "Articles",
      founder: "The Founder",
      services: "Advertising & Communication",
      appointment: "Book an appointment",
      quote: "Request a quote",
      client: "Client area",
      login: "Sign in",
      logout: "Sign out",
      dashboard: "My space",
      admin: "Administration",
    },
    home: {
      overline: "African perspective · Global reach",
      h1: "The continent's economic intelligence, with the rigor of a global reference.",
      sub: "For over a decade, GLOBAL AFRIQUE INTERNATIONAL has informed executives, investors and institutions on Africa's strategic transformations.",
      ctaMag: "Open the magazine",
      ctaQuote: "Request a quote",
      latest: "Editorial highlights",
      topRank: "TOP BANKS & TOP COMPANIES rankings",
      topRankDesc: "Our annual observatory of pan-African economic champions — a strategic read recognised by executives, authorities and international organisations.",
      founder: "The Founder",
      founderSub: "A pan-African vision, an editorial signature.",
      readMore: "Read article",
      viewAll: "View all articles",
      reachOverline: "International distribution",
      reachTitle: "A decision-maker audience in over 100 countries",
      reachItems: [
        { k: "100+", v: "Countries covered" },
        { k: "10+", v: "Years of expertise" },
        { k: "N°1", v: "Pan-African business magazine" },
        { k: "1M+", v: "Qualified readers" },
      ],
      quoteBlock: "Our pricing is tailor-made. Share your needs — we reply within 48 business hours with a personalised proposal.",
      newsletter: "Receive our digital editions",
      newsletterSub: "Subscribe to our confidential newsletter for executives.",
      subscribe: "Subscribe",
      subscribed: "Thanks — you are subscribed.",
    },
    magazine: {
      title: "Digital Kiosk",
      sub: "Every GAI edition, in an immersive reading mode.",
      read: "Open edition",
      download: "Download PDF",
      noPdf: "PDF coming soon",
    },
    articles: {
      title: "Articles",
      sub: "Analyses, rankings, interviews and strategic dossiers.",
      cats: {
        all: "All",
        finance: "Finance",
        politique: "Politics",
        "socio-culturel": "Socio-cultural",
        interview: "Interviews",
        top: "Rankings",
      },
    },
    founder: {
      title: "Mrs Bijoux Milton Kilandamoko",
      role: "Founder & Publisher — GLOBAL AFRIQUE INTERNATIONAL",
      quote: "\"To make Africa a reading of the world, and the world a reading of Africa.\"",
      bio: "A committed pan-African entrepreneur, Mrs Bijoux Milton Kilandamoko has led GLOBAL AFRIQUE INTERNATIONAL since its creation. A journalist and communication strategist, she built in a decade a reference media platform, present in over 100 countries, recognised by the highest authorities, executives, bankers and international organisations.",
      vision: "Her vision: position Africa as a structuring player in the global economic debate — with an engaged, independent and demanding editorial line.",
      cta: "Book a private meeting",
    },
    services: {
      title: "Advertising & Communication",
      sub: "A complete offer to strengthen your visibility and impact in Africa.",
      blocks: [
        { t: "Advertising sales", d: "Premium placements in the magazine, special issues, targeted executive campaigns." },
        { t: "Institutional communication", d: "Executive speeches, strategic dossiers, continental PR." },
        { t: "Premium content", d: "Exclusive interviews, portraits, case studies, sector reports." },
        { t: "Media partnerships", d: "Co-editions, events, co-signed rankings, pan-African & international distribution." },
      ],
      pricing: "Rates are not public. Every arrangement is subject to a custom proposal.",
      cta: "Request a quote",
    },
    quote: {
      title: "Custom quote request",
      sub: "Tell us everything — our commercial team replies within 48 business hours.",
      fullName: "Full name",
      company: "Company",
      email: "Business email",
      phone: "Phone",
      country: "Country",
      service: "Request type",
      budget: "Indicative budget",
      message: "Your project",
      services: {
        publicite: "Magazine advertising",
        regie: "Advertising representation",
        communication: "Institutional communication",
        partenariat: "Media partnership",
        "contenu-premium": "Premium content / Interviews",
      },
      submit: "Send request",
      success: "Request sent. We'll reply within 48 hours.",
      error: "Submission failed. Please try again.",
    },
    appointment: {
      title: "Book a meeting with the Founder",
      sub: "Confidential meetings — by invitation or qualified request.",
      fullName: "Full name",
      email: "Email",
      phone: "Phone",
      company: "Company",
      date: "Preferred date",
      topic: "Meeting subject",
      message: "Context",
      submit: "Send request",
      success: "Request received. The Founder will reach out personally.",
    },
    auth: {
      loginTitle: "Client Area",
      loginSub: "Access your requests, brochures and premium content.",
      registerTitle: "Create an account",
      registerSub: "Reserved for executives, advertisers and qualified partners.",
      email: "Email",
      password: "Password",
      name: "Full name",
      login: "Sign in",
      register: "Create account",
      google: "Continue with Google",
      noAccount: "No account yet?",
      hasAccount: "Already registered?",
      createOne: "Create account",
      signIn: "Sign in",
    },
    dashboard: {
      welcome: "Welcome",
      myQuotes: "My quote requests",
      myAppointments: "My appointments",
      brochures: "Brochures & resources",
      noItem: "Nothing yet.",
      download: "Download",
      logout: "Sign out",
    },
    admin: {
      title: "GAI Administration",
      stats: "Overview",
      articles: "Articles",
      magazines: "Magazines",
      brochures: "Brochures",
      quotes: "Quote requests",
      appointments: "Appointments",
      newArticle: "New article",
      newMagazine: "New edition",
    },
    footer: {
      tagline: "Pan-African business magazine — Communication & Advertising",
      rights: "All rights reserved",
      legal: "Legal notice",
      privacy: "Privacy",
      contact: "Contact",
    },
    common: {
      loading: "Loading…",
      close: "Close",
      previous: "Previous",
      next: "Next",
      prev: "Previous",
      open: "Open",
      sending: "Sending…",
    },
  },
};
